@if (homeRouteIndex >= 0) {
  <button
    class="home-button"
    mat-stroked-button
    [routerLink]="homeRoute.url"
    >
    <i class="fas fa-home"></i>
    <span>{{homeRoute.name}}</span>
  </button>
}
